module.exports = __webpack_public_path__ + "static/media/fuel_truck.b29e7cb1.svg";